import { defaultFieldBlocks } from '../../multiFieldPro/defaultFieldBlocks.js';
import { deepCopy } from '../deepCopy.js';
import { randomString } from '../randomString.js';
import { toJSONString } from '../toJSONString.js';
import { modalConfirm } from '../modalConfirm.js';
import { modalMsg } from '../modalMsg.js';
import { temporaryId } from '../temporaryId.js';

const multiFieldRemoveProps = [
    'addClass',
    'columns',
    'dataLabelName',
    'description',
    'fields',
    'hasLoopType',
    'includeDraft',
    'innerBlocks',
    'innerGroups',
    'label',
    'maxCount',
    'modalCreate',
    'modalEdit',
    'options',
    'paginate',
    'params',
    'radio',
    'rows',
    'status',
    'type'
];

const multiFieldTextHandles = [
    'text',
    'email',
    'url',
    'tel',
    'password',
    'number',
    'datepicker',
    'date',
    'time',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
];

/**
 * Check the requirement for fieldBlocks['foo'].data
 * @param handle
 * @param fieldBlocks
 * @returns {boolean}
 */
function multiFieldCheckDataProp(handle, fieldBlocks) {
    const type = fieldBlocks[handle].type;
    if (typeof type === 'undefined') {
        alert(`You need to set "type" property to fieldBlocks["${handle}"].`);
        return false;
    }

    const data = fieldBlocks[handle].data;
    if (type === 'table' && Array.isArray(data) === false) {
        alert(`fieldBlocks["${handle}"].data must be Array.`);
        return false;
    } else if (['table-vertical', 'table-vertical-fixed', 'multi-column'].indexOf(type) !== -1 && jQuery.isPlainObject(data) === false) {
        alert(`fieldBlocks["${handle}"].data must be Plain Object.`);
        return false;
    }
    return true;
}

/**
 * Create a new item
 * @param handle
 * @param fieldBlocks
 */
function multiFieldCreateNewItem(handle, fieldBlocks) {
    const newItem = deepCopy(fieldBlocks[handle]);
    multiFieldRemoveProps.forEach((prop) => {
        if (typeof newItem[prop] !== 'undefined') {
            delete newItem[prop];
        }
    });
    newItem.handle = handle;
    newItem.id = randomString();
    return newItem;
}

/**
 * Return default data of a "table", "table-vertical" or "table-vertical-fixed" field
 * @param handle
 * @param fieldBlocks
 * @returns {string|void}
 */
function multiFieldGetDefaultTableRowData(handle, fieldBlocks) {
    if (!multiFieldCheckDataProp(handle, fieldBlocks)) return;

    const fieldBlock = fieldBlocks[handle];
    if (!Array.isArray(fieldBlock.fields)) {
        return alert(`"fieldBlocks.${handle}.fields" must be Array!`);
    }

    const rowData = {};
    fieldBlock.fields.forEach(function (_handle) {
        if (
            typeof fieldBlocks[_handle].data === 'string' ||
            typeof fieldBlocks[_handle].data === 'number' ||
            typeof fieldBlocks[_handle].data === 'boolean'
        ) {
            rowData[_handle] = fieldBlocks[_handle].data;
        } else {
            rowData[_handle] = deepCopy(fieldBlocks[_handle].data);
        }
    });

    return JSON.parse(toJSONString(rowData));
}

/**
 * 柔軟に、かつ規則的にコンテンツを入力できるマルチフィールド
 * @deprecated
 * @requires jQuery, Vue, mtappVars
 * @param options
 */
export function multiField(options) {
    // バージョンチェック
    const version = typeof options.version !== 'undefined' ? Number(options.version) : 1;

    // methods を複製・定義
    const methods = jQuery.extend(
        {},
        {
            setClass: function (handle) {
                let classname = fieldBlocks[handle] && fieldBlocks[handle].class ? fieldBlocks[handle].class : '';
                if (/col-\d+/.test(classname) === false) {
                    classname += ' col-12';
                }
                return classname;
            },
            setColumnClass: function (column) {
                const classes = ['setColumnClass', 'mb-5', 'col'];
                if (column.col) {
                    classes.push('col-' + column.col);
                }
                if (column.class) {
                    classes.push(column.class);
                }
                return classes.join(' ');
            },
            setId: function () {
                return Array.prototype.slice.call(arguments).join('-');
            },
            getType: function (type) {
                const textType = multiFieldTextHandles;
                if (textType.indexOf(type) !== -1) {
                    return 'text';
                }
            },
            addButtonLabel: function (handle) {
                if (typeof fieldBlocks[handle] === 'undefined') {
                    alert('The handle name "' + handle + '" is not found.');
                    return 'Error:' + handle;
                }
                return fieldBlocks[handle].addButtonLabel || fieldBlocks[handle].label;
            },
            assetAddButtonLabel: function (label) {
                return label + 'を選択';
            },
            deepUpdate: function (item) {
                const type = item.type;
                if (typeof item.data === 'undefined' || !item.data) {
                    return;
                }
                if (['table', 'table-vertical', 'table-vertical-fixed', 'multi-column'].indexOf(type) !== -1) {
                    if (version > 1) {
                        item.id = randomString();
                    } else if (Array.isArray(item.data)) {
                        item.data.forEach(function (childItem) {
                            if (childItem.type === 'contentData') {
                                childItem.updated = typeof childItem.updated === 'number' ? childItem.updated + 1 : 1;
                            }
                        });
                    }
                } else if (['multi-column-content'].indexOf(type) !== -1) {
                    item.data.forEach(function (column) {
                        column.forEach(function (childItem) {
                            if (childItem.type === 'contentData') {
                                childItem.updated = typeof childItem.updated === 'number' ? childItem.updated + 1 : 1;
                            }
                        });
                    });
                }
            },
            up: function (i) {
                const array = this.items;
                array.splice(i - 1, 2, array[i], array[i - 1]);
                if (array[i].updated) {
                    array[i].updated++;
                } else {
                    array[i].updated = 1;
                }
                if (array[i - 1].updated) {
                    array[i - 1].updated++;
                } else {
                    array[i - 1].updated = 1;
                }
                this.deepUpdate(array[i]);
                this.deepUpdate(array[i - 1]);
            },
            down: function (i) {
                const array = this.items;
                if (array[i].updated) {
                    array[i].updated++;
                } else {
                    array[i].updated = 1;
                }
                if (array[i + 1].updated) {
                    array[i + 1].updated++;
                } else {
                    array[i + 1].updated = 1;
                }
                array.splice(i, 2, array[i + 1], array[i]);
                this.deepUpdate(array[i]);
                this.deepUpdate(array[i + 1]);
            },
            insert: function (i) {
                const base = this;
                Vue.set(base, 'insertPoint', i);
                const modalElement = document.getElementById('mtapp-mf-modal-' + base.id);
                const modal = new bootstrap.Modal(modalElement);

                modal.show();

                modalElement.addEventListener('hidden.bs.modal', function () {
                    Vue.set(base, 'insertPoint', -1);
                    modal.dispose(); // モーダルインスタンスを破棄
                });
            },
            insertAbove: function () {
                const base = this;
                Vue.set(base, 'insertPointDirection', 0);
            },
            insertBelow: function () {
                const base = this;
                Vue.set(base, 'insertPointDirection', 1);
            },
            remove: function (i) {
                const base = this;
                modalConfirm({
                    type: 'warning',
                    content: '削除しますか？',
                    callback: function () {
                        base.items.splice(i, 1);
                    }
                });
            },
            updateItem: function (i) {
                this.deepUpdate(this.items[i]);
            },
            add: function (field) {
                const app = this;
                if (app.maxBlocks && app.maxBlocks <= app.items.length) {
                    modalMsg({
                        type: app.maxBlocksMessage.type,
                        title: app.maxBlocksMessage.title,
                        content: app.maxBlocksMessage.content.replace(/%maxblocks/gi, app.maxBlocks)
                    });
                    return;
                }
                let newItem = null;
                if (version > 1) {
                    const handle = field;
                    const fieldBlock = fieldBlocks[handle];
                    newItem = multiFieldCreateNewItem(handle, fieldBlocks);
                    // データの初期値をセット : 'table'
                    if (
                        fieldBlock.type === 'table' &&
                        Array.isArray(fieldBlock.fields) &&
                        Array.isArray(fieldBlock.data) &&
                        fieldBlock.data.length === 0
                    ) {
                        newItem.data.push(multiFieldGetDefaultTableRowData(handle, fieldBlocks));
                    }
                    // データの初期値をセット : 'table-vertical-fixed'
                    else if (
                        fieldBlock.type === 'table-vertical-fixed' &&
                        Array.isArray(fieldBlock.fields) &&
                        jQuery.isPlainObject(fieldBlock.data) &&
                        Object.keys(fieldBlock.data).length === 0
                    ) {
                        jQuery.extend(newItem.data, multiFieldGetDefaultTableRowData(handle, fieldBlocks));
                    }
                    // データの初期値をセット : 'multi-column'
                    else if (fieldBlock.type === 'multi-column') {
                        if (!jQuery.isPlainObject(fieldBlock.data)) {
                            newItem.data = {};
                        }
                        if (!Array.isArray(fieldBlock.columns)) {
                            return alert(`You need to set "columns" property to fieldBlocks["${handle}"].`);
                        }
                        fieldBlock.columns.forEach(function (column, i) {
                            if (!Array.isArray(column.fields)) {
                                return alert(`You need to set "fields" property to fieldBlocks["${handle}"].columns[${i}].`);
                            }
                            column.fields.forEach(function (columnFieldsHandle) {
                                // データの初期値をセット : 'multi-column' > 'table'
                                if (
                                    fieldBlocks[columnFieldsHandle].type === 'table' &&
                                    Array.isArray(fieldBlocks[columnFieldsHandle].fields) &&
                                    Array.isArray(fieldBlocks[columnFieldsHandle].data) &&
                                    fieldBlocks[columnFieldsHandle].data.length === 0
                                ) {
                                    newItem.data[columnFieldsHandle] = [multiFieldGetDefaultTableRowData(columnFieldsHandle, fieldBlocks)];
                                }
                                // データの初期値をセット : 'multi-column' > 'table-vertical-fixed'
                                else if (
                                    fieldBlocks[columnFieldsHandle].type === 'table-vertical-fixed' &&
                                    Array.isArray(fieldBlocks[columnFieldsHandle].fields) &&
                                    jQuery.isPlainObject(fieldBlocks[columnFieldsHandle].data) &&
                                    Object.keys(fieldBlocks[columnFieldsHandle].data).length === 0
                                ) {
                                    jQuery.extend(
                                        newItem.data[columnFieldsHandle],
                                        multiFieldGetDefaultTableRowData(columnFieldsHandle, fieldBlocks)
                                    );
                                }
                                // データの初期値をセット : 'multi-column' > 'contentData'
                                else if (fieldBlocks[columnFieldsHandle].type === 'contentData') {
                                    newItem.data[columnFieldsHandle] = multiFieldCreateNewItem(columnFieldsHandle, fieldBlocks);
                                }
                                // データの初期値をセット : 'multi-column' > 'asset' or 'image'
                                else if (
                                    fieldBlocks[columnFieldsHandle].type === 'asset' ||
                                    fieldBlocks[columnFieldsHandle].type === 'image'
                                ) {
                                    newItem.data[columnFieldsHandle] = deepCopy(fieldBlocks[columnFieldsHandle].data);
                                }
                                // データの初期値をセット : 'multi-column' > その他'
                                else if (typeof fieldBlocks[columnFieldsHandle] === 'object') {
                                    if (
                                        typeof fieldBlocks[columnFieldsHandle].data === 'string' ||
                                        typeof fieldBlocks[columnFieldsHandle].data === 'number' ||
                                        typeof fieldBlocks[columnFieldsHandle].data === 'boolean'
                                    ) {
                                        newItem.data[columnFieldsHandle] = fieldBlocks[columnFieldsHandle].data;
                                    } else if (Array.isArray(fieldBlocks[columnFieldsHandle].data)) {
                                        newItem.data[columnFieldsHandle] = [...fieldBlocks[columnFieldsHandle].data];
                                    } else if (Object.prototype.toString.call(fieldBlocks[columnFieldsHandle].data) === '[object Object]') {
                                        newItem.data[columnFieldsHandle] = jQuery.extend({}, fieldBlocks[columnFieldsHandle].data);
                                    } else {
                                        newItem.data[columnFieldsHandle] = multiFieldCreateNewItem(columnFieldsHandle, fieldBlocks);
                                    }
                                }
                            });
                        });
                    }
                } else {
                    newItem = JSON.parse(toJSONString(field));
                    newItem.id = temporaryId();
                    let data = newItem.data ? newItem.data : '';
                    let childData = '';

                    /**
                     * table 内の各フィールド（セル）に ID を付与する
                     * @param {array} data
                     * @returns {*}
                     */
                    const setIdToTableField = function (data) {
                        for (let i = 0, l = data.length; i < l; i++) {
                            for (let x = 0, y = data[i].length; x < y; x++) {
                                data[i][x].id = temporaryId();
                            }
                        }
                        return data;
                    };

                    if (field.type === 'table') {
                        data = JSON.parse('[' + toJSONString(field.options) + ']');
                        data = setIdToTableField(data);
                    } else if (field.type === 'table-vertical' || field.type === 'table-vertical-fixed') {
                        data = JSON.parse(toJSONString(field.options));
                        for (let i = 0, l = data.length; i < l; i++) {
                            data[i].id = temporaryId();
                        }
                    } else if (field.type === 'multi-column') {
                        data = JSON.parse(toJSONString(field.options));
                        for (let i = 0, l = data.length; i < l; i++) {
                            if (data[i].type === 'table') {
                                childData = JSON.parse('[' + toJSONString(data[i].options) + ']');
                                data[i].data = setIdToTableField(childData);
                            }
                            data[i].id = temporaryId();
                        }
                    } else if (field.type === 'multi-column-content') {
                        data = JSON.parse(toJSONString(field.options));
                        for (let i = 0; i < data.length; i++) {
                            for (let j = 0; j < data[i].length; j++) {
                                if (data[i][j].type === 'table') {
                                    childData = JSON.parse('[' + toJSONString(data[i][j].options) + ']');
                                    data[i][j].data = setIdToTableField(childData);
                                }
                                data[i][j].id = temporaryId();
                            }
                        }
                    } else if (field.type === 'listing') {
                        data = [];
                    }
                    newItem.data = data;
                    app.addType = field.type;
                }
                if (app.insertPoint !== -1) {
                    app.items.splice(app.insertPoint + app.insertPointDirection, 0, newItem);
                    app.ts = new Date().getTime();
                } else {
                    app.items.push(newItem);
                }
                app.insertPoint = -1;
            },
            onInput: function () {},
            onChange: function () {},
            onCheck: function () {},
            onApply: function () {},
            onChangeAsset: function () {},
            onChangeImage: function () {},
            // コンポーネント : VueContentData
            vueContentDataSaved: function () {},
            vueListContentData: function () {}
        },
        options.methods
    );

    if (version === 1) {
        delete options.methods;
    }

    // watch を複製・定義
    const watch = options.watch ? jQuery.extend({}, options.watch) : null;

    if (version === 1) {
        delete options.watch;
    }

    /**
     * フィールドの定義
     *
     * fieldBlocks: {
     *   uniqueFieldHandle: {
     *     type: 'fieldType', // フィールドのタイプ
     *     label: 'fieldLabel', // フィールドのラベル
     *     data: '', // 保存されるデータの受け皿
     *     url: '', // type が asset と image の場合のみ
     *     thumbnail: '', // type が image の場合のみ
     *     rows: '', // テキストエリアの初期行数（オプション）
     *     options: [], // 選択系フィールドの選択肢（オプション）
     *     },
     * }
     */
    options.fieldBlocks = options.fieldBlocks || {};
    const fieldBlocks = jQuery.extend({}, defaultFieldBlocks, options.fieldBlocks);

    const data = jQuery.extend(
        {
            debug: false,
            addType: '',
            showAddContainer: false,
            showAddFieldButton: true,
            showViewRawDataButton: false,
            showSortButton: true,
            showInsertButton: true,
            showRemoveButton: true,
            addFieldButtonLabel: 'フィールドを追加',
            insertPoint: -1,
            insertPointDirection: 0,
            items: [],
            version: version,
            minBlocks: 0,
            maxBlocks: 0,
            maxBlocksType: '',
            maxBlocksMessage: {
                type: 'warning',
                title: 'お知らせ',
                content: '<p class="mb-0"><strong>最大ブロック数は %maxblocks です。</strong></p>'
            },
            updated: 0,
            /**
             * {
             *   type: 'fieldType', // フィールドのタイプ（一意）
             *   label: 'フィールドラベル', // フィールドのラベル
             *   yourFieldHandle: '初期値'
             * }
             */
            fieldGroups: [
                [
                    { type: 'h1', label: '見出し1', data: '' },
                    { type: 'h2', label: '見出し2', data: '' },
                    { type: 'h3', label: '見出し3', data: '' },
                    { type: 'h4', label: '見出し4', data: '' },
                    { type: 'h5', label: '見出し5', data: '' },
                    { type: 'h6', label: '見出し6', data: '' }
                ],
                [
                    { type: 'text', label: '1行テキスト', data: '' },
                    { type: 'email', label: 'Email', data: '' },
                    { type: 'url', label: 'URL', data: '' },
                    { type: 'tel', label: '電話番号', data: '' },
                    { type: 'password', label: 'パスワード', data: '' },
                    { type: 'number', label: '数値', data: '' },
                    { type: 'datepicker', label: '日付', data: '' },
                    { type: 'time', label: '時刻', data: '' },
                    { type: 'textarea', label: '複数行テキスト', rows: 8, data: '' },
                    { type: 'code', label: 'コードブロック', rows: 4, data: '' },
                    { type: 'tinymce', label: 'リッチテキスト', rows: 8, data: '' },
                    { type: 'asset', label: 'ファイル', url: '', data: '' },
                    { type: 'image', label: '画像', data: '', url: '', thumbnail: '', alt: '' }
                ],
                [
                    {
                        type: 'contentData',
                        label: 'コンテンツデータ',
                        siteId: 1,
                        contentTypeId: 1,
                        radio: false,
                        modalEdit: true,
                        modalCreate: true,
                        includeDraft: false,
                        dataLabelName: 'title',
                        data: ''
                    }
                ],
                [
                    {
                        type: 'select',
                        label: 'ドロップダウンリスト',
                        options: [
                            { label: 'リンゴ', data: 'apple' },
                            { label: 'オレンジ', data: 'orange' },
                            { label: 'キウィフルーツ', data: 'kiwi' }
                        ]
                    },
                    {
                        type: 'checkbox',
                        label: 'チェックボックス',
                        options: [
                            { label: 'リンゴ', data: 'apple', checked: false },
                            { label: 'オレンジ', data: 'orange', checked: false },
                            { label: 'キウィフルーツ', data: 'kiwi', checked: false }
                        ]
                    },
                    {
                        type: 'radio',
                        label: 'ラジオボタン',
                        options: [
                            { label: 'リンゴ', data: 'apple' },
                            { label: 'オレンジ', data: 'orange' },
                            { label: 'キウィフルーツ', data: 'kiwi' }
                        ]
                    },
                    {
                        type: 'table',
                        label: '表',
                        options: [
                            { type: 'text', label: '1行テキスト' },
                            { type: 'datepicker', label: '日付' },
                            { type: 'time', label: '時刻' },
                            { type: 'textarea', label: '複数行テキスト', rows: 1 },
                            { type: 'tinymce', label: 'リッチエディタ', rows: 8 },
                            { type: 'asset', label: 'ファイル', filename: '' },
                            { type: 'image', label: '画像', filename: '', thumbnail: '' },
                            {
                                type: 'select',
                                label: 'ドロップダウンリスト',
                                options: [
                                    { label: 'リンゴ', data: 'apple' },
                                    { label: 'オレンジ', data: 'orange' },
                                    { label: 'キウィフルーツ', data: 'kiwi' }
                                ]
                            },
                            {
                                type: 'checkbox',
                                label: 'チェックボックス',
                                options: [
                                    { label: 'リンゴ', data: 'apple' },
                                    { label: 'オレンジ', data: 'orange' },
                                    { label: 'キウィフルーツ', data: 'kiwi' }
                                ]
                            },
                            {
                                type: 'radio',
                                label: 'ラジオボタン',
                                options: [
                                    { label: 'リンゴ', data: 'apple' },
                                    { label: 'オレンジ', data: 'orange' },
                                    { label: 'キウィフルーツ', data: 'kiwi' }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'table-vertical-fixed',
                        label: '縦向き固定テーブル',
                        options: [
                            { type: 'text', label: '1行テキスト' },
                            { type: 'datepicker', label: '日付' },
                            { type: 'time', label: '時刻' },
                            { type: 'textarea', label: '複数行テキスト', rows: 1 },
                            { type: 'tinymce', label: 'リッチエディタ', rows: 8 },
                            { type: 'asset', label: 'ファイル' },
                            { type: 'image', label: '画像' },
                            {
                                type: 'select',
                                label: 'ドロップダウンリスト',
                                options: [
                                    { label: 'リンゴ', data: 'apple' },
                                    { label: 'オレンジ', data: 'orange' },
                                    { label: 'キウィフルーツ', data: 'kiwi' }
                                ]
                            },
                            {
                                type: 'checkbox',
                                label: 'チェックボックス',
                                options: [
                                    { label: 'リンゴ', data: 'apple' },
                                    { label: 'オレンジ', data: 'orange' },
                                    { label: 'キウィフルーツ', data: 'kiwi' }
                                ]
                            },
                            {
                                type: 'radio',
                                label: 'ラジオボタン',
                                data: 'orange',
                                options: [
                                    { label: 'リンゴ', data: 'apple' },
                                    { label: 'オレンジ', data: 'orange' },
                                    { label: 'キウィフルーツ', data: 'kiwi' }
                                ]
                            }
                        ]
                    }
                ],
                [
                    {
                        type: 'multi-column',
                        label: '2段組リッチテキスト',
                        options: [
                            { type: 'tinymce', col: 6 },
                            { type: 'tinymce', col: 6 }
                        ]
                    },
                    {
                        type: 'multi-column',
                        label: '3段組テキスト',
                        options: [
                            { type: 'textarea', rows: 8, col: 4 },
                            { type: 'textarea', rows: 8, col: 4 },
                            { type: 'textarea', rows: 8, col: 4 }
                        ]
                    },
                    {
                        type: 'multi-column-content',
                        label: '2段組コンテンツ',
                        options: [
                            [
                                { type: 'text', label: '小見出し' },
                                { type: 'tinymce', label: '本文' }
                            ],
                            [
                                { type: 'text', label: '小見出し' },
                                { type: 'tinymce', label: '本文' }
                            ]
                        ]
                    }
                ],
                [
                    {
                        type: 'textarea',
                        label: '定型文（セミナー案内）',
                        rows: 8,
                        data: '日時：\n\n会場：\n\n参加費：\n\n申し込み期限：'
                    }
                    // ],
                    // [
                    //   {
                    //     type: 'listing', label: '関連商品', url: '', options: [
                    //       {label: 'ID', data: 'id'},
                    //       {label: '名前', data: 'name'}
                    //     ]
                    //   }
                ]
            ]
        },
        options
    );

    data.fieldBlocks = fieldBlocks;
    const fieldId = data.id;
    let target = null;
    let savedData = '';
    let isRequired = false;

    const warning = mtappVars.use_vue2
        ? ''
        : `<div class="alert alert-danger"><strong class="d-block mb-3">${options.label}</strong>${mtappVars.translate['Warning for Vue 2 Setting']}</div>`;
    // 記事・ウェブページ・カテゴリ編集画面に対応
    if (mtappVars.screen_id === 'edit-entry' || mtappVars.screen_id === 'edit-page' || mtappVars.screen_id === 'edit-category') {
        target = document.getElementById(fieldId);
        if (!target) {
            return;
        }
        savedData = target.value;
        const $fieldBlock = jQuery('#' + fieldId + '-field');
        if ($fieldBlock.hasClass('required')) {
            isRequired = true;
        }
        $fieldBlock.after(`<div id="mtapp-mf-${fieldId}">${warning}</div>`).remove();
    }
    // コンテンツデータ
    else {
        if (
            typeof mtappVars.contentDataFields === 'undefined' ||
            typeof mtappVars.contentDataFields['contentField' + fieldId] === 'undefined'
        ) {
            return;
        }
        target = document.querySelector('[name="content-field-' + fieldId + '"]');
        if (target.required) {
            isRequired = true;
        }
        savedData = target.value;
        target.value = '{}';
        jQuery(mtappVars.contentDataFields['contentField' + fieldId])
            .find('#block_editor_data')
            .appendTo('#edit-content-type-data-form');
        jQuery(mtappVars.contentDataFields['contentField' + fieldId])
            .find('.modal-blockeditor')
            .appendTo('#edit-content-type-data-form');
        jQuery(mtappVars.contentDataFields['contentField' + fieldId])
            .after(`<div id="mtapp-mf-${fieldId}">${warning}</div>`)
            .hide()
            .find('textarea')
            .attr('name', '');
    }

    if (warning) {
        return;
    }

    // 必須アイコンを付ける
    data.isRequired = isRequired;

    // 保存されているデータを変換
    if (savedData) {
        savedData = JSON.parse(savedData);
        data.items = JSON.parse(toJSONString(savedData.items));
        data.items.forEach(function (item) {
            // 後方互換
            if (['table-vertical'].indexOf(item.type) !== -1) {
                if (typeof item.data === 'undefined' || !item.data) {
                    item.data = JSON.parse(toJSONString(item.options));
                }
            }
            // multi-column の中の table-vertical のバグによるデータのマイグレーション
            if (!Object.prototype.hasOwnProperty.call(item, 'handle')) {
                return;
            }
            const fieldBlock = fieldBlocks[item.handle];
            if (fieldBlock.type === 'multi-column') {
                const allFieldsInMultiColumn = [];
                fieldBlock.columns.forEach(function (column) {
                    column.fields.forEach(function (fieldHandle) {
                        allFieldsInMultiColumn.push(fieldHandle);
                    });
                });
                fieldBlock.columns.forEach(function (column) {
                    column.fields.forEach(function (fieldHandle) {
                        if (fieldBlocks[fieldHandle].type.startsWith('table-vertical') && typeof item.data[fieldHandle] === 'undefined') {
                            item.data[fieldHandle] = {};
                            fieldBlocks[fieldHandle].fields.forEach(function (tableFieldHandle) {
                                item.data[fieldHandle][tableFieldHandle] = deepCopy(item.data[tableFieldHandle]);
                                if (!allFieldsInMultiColumn.includes(tableFieldHandle)) {
                                    delete item.data[tableFieldHandle];
                                }
                            });
                        }
                    });
                });
            }
        });
    }

    // 仮IDをフィールドにセット
    for (let i = 0; i < data.items.length; i++) {
        if (typeof data.items[i].id === 'undefined') {
            data.items[i].id = temporaryId();
        }
    }

    // Vue インスタンスを作成
    mtappVars.multiField = mtappVars.multiField || {};
    mtappVars.multiField['field' + fieldId] = {
        app: null,
        options: null
    };

    mtappVars.multiField['field' + fieldId].app = new Vue({
        el: '#mtapp-mf-' + fieldId,
        template: '#mf-container-tmpl' + (version === 2 ? '-v2' : ''),
        data: data,
        // updated: function () {
        //   this.$nextTick(function () {
        //     console.warn('ビュー全体が再レンダリングされた後にのみ実行されるコード');
        //     console.warn(this);
        //   })
        // },
        mounted: function () {
            // body に各フィールドのイベントを付与
            jQuery('body').on('focus.mtapp-mf-field-datepicker', 'input.mtapp-mf-field-datepicker', function () {
                if (!jQuery(this).hasClass('hasDatepicker')) {
                    jQuery(this).datepicker({
                        dateFormat: 'yy-mm-dd',
                        dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
                        monthNames: ['- 01', '- 02', '- 03', '- 04', '- 05', '- 06', '- 07', '- 08', '- 09', '- 10', '- 11', '- 12'],
                        showMonthAfterYear: true,
                        prevText: '&lt;',
                        nextText: '&gt;',
                        onSelect: function () {
                            this.dispatchEvent(mtappVars.eventInput);
                        }
                    });
                }
            });
        },
        created: function () {
            this.ts = new Date().getTime();
        },
        updated: function () {
            // nothing to do
        },
        computed: {
            setContentData: function () {
                const items = this.items;
                const version = this.version;
                const data = { items: items, version: version, ts: this.ts };
                return toJSONString(data);
            },
            disabledAdd: function () {
                return this.maxBlocks > 0 && this.maxBlocks <= this.items.length;
            }
        },
        methods: methods,
        watch: watch
    });
}
